import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { EntrySummaryShortModel } from '@data-layer/models/entry-summaries';
import { enumTransportationMode } from '@data-layer/enums/entry-summaries';
import { DEFAULT_CURRENCY_CODE } from '@constants/currency';
import { DocumentModel } from '@data-layer/models/documents';
import { CompaniesService } from '@services/companies.service';
import { EntrySummaryStateService } from '@shared/es-mutual/services';

@Component({
  selector: 'es-batch-items',
  templateUrl: './es-batch-items.component.html',
  styleUrls: ['./es-batch-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EsBatchItemsComponent {
  @Input() public checkedItemIds: number[] = [];
  @Input() public esItems: EntrySummaryShortModel[] = [];
  @Input() public documents: DocumentModel[] = [];
  @Output() public isCheckedChange: EventEmitter<{ id: number; checked: boolean }> = new EventEmitter<{ id: number; checked: boolean }>();
  @Output() public isCheckedAllChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public review: EventEmitter<number> = new EventEmitter<number>();

  public enumESTransportationMode: typeof enumTransportationMode = enumTransportationMode;
  public DEFAULT_CURRENCY_CODE: typeof DEFAULT_CURRENCY_CODE = DEFAULT_CURRENCY_CODE;

  constructor(
    private cdr: ChangeDetectorRef,
    private companiesService: CompaniesService,
    private entrySummaryStateService: EntrySummaryStateService,
  ) {}

  public markDataForCheck(): void {
    this.cdr.markForCheck();
  }

  public filesCount(id: number): number {
    return (this.documents || []).filter((item: DocumentModel) => item.rootEntityId === id)?.length;
  }

  public isFilesValid(es: EntrySummaryShortModel): boolean {
    return this.entrySummaryStateService.isFilesValid(es, this.documents);
  }

  public isChecked(id: number): boolean {
    return this.checkedItemIds.includes(id);
  }

  public isCheckedNext(index: number): boolean {
    if (index >= this.esItems.length) {
      return false;
    }

    return this.checkedItemIds.includes(this.esItems?.[index + 1]?.id);
  }

  public get isAllChecked(): boolean {
    if (!this.esItems.length) {
      return false;
    }

    return this.checkedItemIds.length === this.esItems.length;
  }

  public get isAllInvalid(): boolean {
    if (!this.esItems.length) {
      return false;
    }

    return this.esItems.every((item: EntrySummaryShortModel) => !item.valid);
  }
}
